function parseStrToNum(string?: string) {
  return !isNaN(Number(string)) ? Number(string) : undefined;
}

export default parseStrToNum;
